/* import __COLOCATED_TEMPLATE__ from './installed-badge.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();